var _classCallCheck = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\classCallCheck.js");

var _createClass = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\createClass.js");

var _inherits = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\inherits.js");

var _possibleConstructorReturn = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\possibleConstructorReturn.js");

var _getPrototypeOf = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EventEmitter = require('events');

var dev = process.env.NODE_ENV === 'development';

var ConnectionManager = /*#__PURE__*/function (_EventEmitter) {
  "use strict";

  _inherits(ConnectionManager, _EventEmitter);

  var _super = _createSuper(ConnectionManager);

  function ConnectionManager(connections, targets, options) {
    var _this;

    _classCallCheck(this, ConnectionManager);

    _this = _super.call(this);
    _this.targets = targets;
    _this.options = options;
    _this.connections = connections;
    _this.connected = false;
    _this.status = 'loading';
    _this.interval = options.interval || 5000;
    _this.name = options.name || 'default';
    _this.inSetup = true;

    _this.connect();

    return _this;
  }

  _createClass(ConnectionManager, [{
    key: "connect",
    value: function connect() {
      var _this2 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (dev && index === 0) console.log("\n\n\n\nA connection cycle started for provider with name: ".concat(this.name));

      if (this.connection && this.connection.status === 'connected' && index >= this.connection.index) {
        if (dev) console.log('Stopping connection cycle becasuse we\'re already connected to a higher priority provider');
      } else if (this.targets.length === 0) {
        if (dev) console.log('No valid targets supplied');
      } else {
        var _this$targets$index = this.targets[index],
            protocol = _this$targets$index.protocol,
            location = _this$targets$index.location;
        this.connection = this.connections[protocol](location, this.options);
        this.connection.on('error', function (err) {
          if (!_this2.connected) return _this2.connectionError(index, err);
          if (_this2.listenerCount('error')) return _this2.emit('error', err);
          console.warn('eth-provider - Uncaught connection error: ' + err.message);
        });
        this.connection.on('close', function () {
          _this2.connected = false;

          _this2.emitClose();

          if (!_this2.closing) _this2.refresh();
        });
        this.connection.on('connect', function () {
          _this2.connection.target = _this2.targets[index];
          _this2.connection.index = index;
          _this2.targets[index].status = _this2.connection.status;
          _this2.connected = true;
          _this2.inSetup = false;
          if (dev) console.log('Successfully connected to: ' + _this2.targets[index].location);

          _this2.emit('connect');
        });
        this.connection.on('data', function (data) {
          return _this2.emit('data', data);
        });
        this.connection.on('payload', function (payload) {
          return _this2.emit('payload', payload);
        });
      }
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var _this3 = this;

      var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.interval;
      if (dev) console.log("Reconnect queued for ".concat((interval / 1000).toFixed(2), "s in the future"));
      clearTimeout(this.connectTimer);
      this.connectTimer = setTimeout(function () {
        return _this3.connect();
      }, interval);
    }
  }, {
    key: "connectionError",
    value: function connectionError(index, err) {
      if (this.connection && this.connection.close) this.connection.close();
      this.targets[index].status = err;

      if (this.targets.length - 1 === index) {
        this.inSetup = false;
        if (dev) console.warn('eth-provider unable to connect to any targets, view connection cycle summary: ', this.targets);
        this.refresh();
      } else {
        // Not last target, move on the next connection option
        this.connect(++index);
      }
    }
  }, {
    key: "emitClose",
    value: function emitClose() {
      this.emit('close');
    }
  }, {
    key: "close",
    value: function close() {
      this.closing = true;

      if (this.connection && this.connection.close && !this.connection.closed) {
        this.connection.close(); // Let event bubble from here
      } else {
        this.emit('close');
      }

      clearTimeout(this.connectTimer);
      clearTimeout(this.setupTimer);
    }
  }, {
    key: "error",
    value: function error(payload, message) {
      var code = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
      this.emit('payload', {
        id: payload.id,
        jsonrpc: payload.jsonrpc,
        error: {
          message: message,
          code: code
        }
      });
    }
  }, {
    key: "send",
    value: function send(payload) {
      var _this4 = this;

      if (this.inSetup) {
        this.setupTimer = setTimeout(function () {
          return _this4.send(payload);
        }, 100);
      } else if (this.connection.closed) {
        this.error(payload, 'Not connected', 4900);
      } else {
        this.connection.send(payload);
      }
    }
  }]);

  return ConnectionManager;
}(EventEmitter);

module.exports = ConnectionManager;